import * as Models from '../../../models';
import { MapperApi2_0 } from '../../../mappers';
import { ExamStatsEndpoints } from '../../../';

export interface GetExamStatsResponse extends Models.Response.ResourcesListBasic {
  resources: Models.ExamStats[];
}

export const getExamsStats = async (params: Parameters<typeof ExamStatsEndpoints.getExamStats>[0]) => {
  return ExamStatsEndpoints.getExamStats(params)
    .then(data => {
      return {
        resources: MapperApi2_0.mapExamsStats(data.resources),
      };
    })
    .catch(() => {
      return {
        resources: [],
      };
    });
};
